
import request from '@/utils/request'

export function depositList(data) {
  return request({
    url: '/ustn/depositList',
    method: 'get',
    params: data
  })
}
